import { AxiosError } from 'axios';
import { Context } from '@vue-storefront/core';
import { OAuthToken } from '@vsf-enterprise/sapcc-api';
import { ConcurrentCallbacksReducer } from '@vsf-enterprise/sapcc';
import {
  getHeadersWithRetriesLeft,
  getHeadersWithTokenCookie,
  serializeTokenCookie,
  shouldRetry,
  getRetriesLeft,
  shouldRefreshToken,
  refreshUserToken,
  getCurrentToken,
  clearAuthCookies
} from '@vsf-enterprise/sapcc/nuxt/refresh-token-interceptor/helpers';

const logoutRoute = { name: 'home', query: { logout: 'expired' } };

export default async function refreshTokenPlugin (context: Context) {
  const { localePath, app, redirect } = context;
  const { client } = app.$vsf.$sapcc;

  const reduceConcurrentCallbacks = new ConcurrentCallbacksReducer().reduce;
  let refreshedUserToken: OAuthToken | null;

  client.interceptors.response.use(undefined, async (error: AxiosError) => {
    const retriesLeft = getRetriesLeft(error);
    const currentToken = getCurrentToken(context, refreshedUserToken);

    if (!shouldRetry(error, retriesLeft)) {
      return Promise.reject(error);
    }

    if (shouldRefreshToken(error, currentToken)) {
      try {
        await reduceConcurrentCallbacks(async () => {
          refreshedUserToken = await refreshUserToken(context);
        });
      } catch {
        clearAuthCookies(context);
        redirect(localePath(logoutRoute));
        return;
      }
    }

    const { config } = error;

    config.headers = getHeadersWithRetriesLeft(error, retriesLeft - 1);
    if (process.server) {
      const serializedTokenCookie = serializeTokenCookie(refreshedUserToken as OAuthToken);
      config.headers = getHeadersWithTokenCookie(error, serializedTokenCookie);
    }

    return client(config);
  });
}
